module.exports = function getResource(label, vars = []) {
    let resources = {
        viewFullSizeLabel: 'View Full Size',
        viewDetailsLabel: 'View Details'
    };
    return resources[label];
};
